module.exports = __webpack_public_path__ + "img/3_36.f4774232.png";